export default __webpack_public_path__ + "static/media/Head_5_Ear_1_C1.922f1369.svg";